__webpack_require__.p = "https://victorious-bay-01aa94a03.2.azurestaticapps.net/";